var _path, _path2, _g, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnexpectedError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 132,
  height: 150,
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fee6c3",
  fillRule: "nonzero",
  stroke: "none",
  d: "M70.481 0H11.507C5.16.02.019 5.36 0 11.952v125.489c.019 6.593 5.16 11.932 11.507 11.952h86.304c6.346-.02 11.487-5.359 11.507-11.951V37.202z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinejoin: "miter",
  strokeWidth: 10,
  d: "M19.244 125.99h54.089m-54.089-19.93H65.11M19.244 86.133h31.064M19.244 66.205H37.12"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.268 39.993 68.99 4.518l35.382 33.089z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f3594e",
  d: "M90.98 89.248c0-10.551 8.18-19.046 18.338-19.046s18.338 8.495 18.338 19.046-8.179 19.046-18.338 19.046S90.98 99.799 90.98 89.248"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeLinejoin: "miter"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 5,
  d: "M89.177 89.248c0-11.589 8.983-20.919 20.141-20.919s20.14 9.33 20.14 20.919-8.982 20.919-20.14 20.919-20.141-9.33-20.141-20.92z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 6,
  d: "M108.985 78.444v12.872"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  stroke: "none",
  d: "M106.85 98.328c0-1.246.966-2.248 2.165-2.248s2.164 1.002 2.164 2.248-.965 2.248-2.164 2.248-2.164-1.003-2.164-2.248"
})));
export { SvgUnexpectedError as ReactComponent };
export default __webpack_public_path__ + "images/unexpected-error.51f89c0e.svg";